import { useTracking } from '@vp/react-tracking';
import React from 'react';
import { Box, Card, FlexBox, Link, ResponsiveImage, Typography } from '@vp/swan';
import { transformToAnalyticsUrl } from '../../utils/transformToAnalyticsUrl';

interface FeaturedCardProps {
    destinationUrl: string;
    destinationPageName: string;
    image: string;
    title: string;
    subtitle: React.ReactNode;
    position: number;
}

export default function FeaturedCard(props: FeaturedCardProps) {
    const { tracking } = useTracking();
    const { destinationUrl, destinationPageName, image, title, subtitle, position } = props;
    const sourceUrl = window.location.pathname;
    const analyticsDestinationUrl = transformToAnalyticsUrl(destinationUrl);
    const ctaValue = `expertServices-${destinationPageName}-startAProject`;
    const sendAnalyticsForFeatureCard = () =>
        tracking.track('Fly-Out Clicked', {
            action: 'Fly-Out Clicked',
            category: 'Fly-Out',
            label: 'My Design Services:Fly-Out',
            eventDetail: `${sourceUrl};${analyticsDestinationUrl};My Design Service flyout CTA;${ctaValue}`,
            navigationDetail: `${ctaValue}:${position}`,
            pageSection: 'Design Services',
            pageStage: 'My Account',
            pageName: 'Design Services:Dashboard',
        });
    return (
        <Card
            skin="link"
            marginBottom={'4'}
            style={{
                borderRadius: '12px',
                minHeight: '79px',
                boxSizing: 'content-box',
                overflow: 'hidden',
            }}
            fullBleed
            bordered
        >
            <FlexBox flexDirection="row" alignItems={'center'}>
                <ResponsiveImage src={image} alt={title} height={79} width={79} marginRight={'5'} />
                <Box marginRight={'4'}>
                    <Box>
                        <Typography fontSize="xsmall" fontWeight="bold" mb={'2'}>
                            {title}
                        </Typography>
                        <Typography fontSize="xsmall">{subtitle}</Typography>
                    </Box>
                </Box>
                <Link href={destinationUrl} onClick={sendAnalyticsForFeatureCard} covering />
            </FlexBox>
        </Card>
    );
}
